import { useI18n } from "@core/i18n/i18n";
import { networkActionsErrorsManager, networkDebugManager } from "@core/service-container";
import { ToastContext } from "@ui/components/common/toast-provider";
import { useObservable } from "micro-observables";
import React, { useContext, useEffect } from "react";

export const NetworkErrorReporter: React.FC = () => {
	const { format } = useI18n();
	const actionError = useObservable(networkActionsErrorsManager.actionErrors);
	const debugSettings = useObservable(networkDebugManager.debugSettings);
	const { showToast } = useContext(ToastContext);

	useEffect(() => {
		if (actionError) {
			showToast(
				actionError.title ?? format("global.toast.error.title"),
				actionError.message ?? format("global.toast.error.message"),
			);
			networkActionsErrorsManager.clearError();
		}
	}, [actionError, format, showToast]);

	useEffect(() => {
		if (debugSettings.enableRandomNetworkErrors) {
			showToast("DEBUG", "Random network errors are active", "warn");
		}
	}, [debugSettings, format, showToast]);

	return <></>;
};
